import "./Home.module.css";
import CabecalhoInstitucional from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import CriticalEnvironmentsEngineering from "./sections/CriticalEnvironmentsEngineering";
import CardGrid from "./sections/CardGrid";
import InovacaoEmEquipamentos from "./sections/InovacaoEmEquipamentos";
import EngineeringCycle from "./sections/EngineeringCycle";
import AuthorityAndLegacy from "./sections/AuthorityAndLegacy";
import ProjetosDeReferencia from "./sections/ProjetosDeReferencia";
import ConsultoriaTecnicaImediata from "./sections/ConsultoriaTecnicaImediata";
import InformativeFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CabecalhoInstitucional />
      <Hero />
      <CriticalEnvironmentsEngineering />
      <CardGrid />
      <InovacaoEmEquipamentos />
      <EngineeringCycle />
      <AuthorityAndLegacy />
      <ProjetosDeReferencia />
      <ConsultoriaTecnicaImediata />
      <InformativeFooter />
    </div>;
}